module.exports = __webpack_public_path__ + "assets/4f9b7df7f6274a1b10cd84e6631213e0.mp3";